import _ from 'lodash'
import { extractError } from '../service/response.service'
import { extendObservable } from 'mobx'
import { api } from '../service/api.service'
import { inboxCategories } from '../config'
import User from './user.store'

class AlertStore {
  constructor() {
    extendObservable(this, {
      alerts: [],
      categories: [],
      selectedCategory: 'contracts',
      schedules: [],
      loading: false
    })
  }

  getAllAlerts = () => {
    api.get('/alert')
      .then(res => {
    const alerts = res?.data
    const allContractNumbers = User?.contractsToProvideDob?.flatMap((p) =>
      p.contracts.map((c) => c.contractNumber)
    )?.join(', ')
    if (User?.showDobProvideAlert) {
      alerts?.unshift({
        id: null,
        type: 'general',
        userId: null,
        userAzureId: null,
        reportId: 'dob',
        seen: true,
        title: 'General',
        titleDe: 'Allgemeines',
        content: `We noticed that one or more partners associated with the following Contracts
          ${allContractNumbers}
          are missing a date of birth.`,
        contentDe: `Uns ist aufgefallen, dass bei einem oder mehreren Partnern der folgenden Verträge das
          ${allContractNumbers}
          das Geburtsdatum fehlt.`,
        status: null,
        adminAlertId: null,
        created_at: new Date(),
        updated_at: new Date()
      })
    }

        const categories = inboxCategories

        let setActive = false
        const remappedCategories = categories.map(c => {
          c.count = 0
          c.newCount = 0
          alerts.forEach(a => {
            if (a.type === c.type && !a.seen && !a?.content?.includes('<p hidden>short</p>')) c.newCount++
            if (a.type === c.type && !a?.content?.includes('<p hidden>short</p>')) {
              c.count++
              if (!setActive) {
                c.active = true
                setActive = true
                this.selectedCategory = c.type
              }
            }
          })
          return c
        })

        this.categories = remappedCategories
        this.alerts = alerts
      })
      .catch(err => {
        this.error = extractError(err)
        this.alerts = []
      })
  }
  markAlertRead = (id) => {
    const isNew = _.find(this.alerts, { id: id, seen: false })
    if (isNew) {
      api
        .post('/alert/mark-read', { id: id })
        .then(res => {
          this.alerts.filter(a => a.id === id)[0].seen = true
          _.find(this.categories, { type: this.selectedCategory }).newCount--
        })
        .catch((err, a) => {
          throw new Error(extractError(err))
        })
    }
  }
  markAllAlertsRead = () => {
    this.alerts.forEach((alert) => {
      const isNew = _.find(this.alerts, { id: alert.id, seen: false })
      if (isNew) {
        api
          .post('/alert/mark-read', { id: alert.id })
          .then(res => {
            this.alerts.filter(a => a.id === alert.id)[0].seen = true
            _.find(this.categories, { type: this.selectedCategory }).newCount--
          })
          .catch((err, a) => {
            throw new Error(extractError(err))
          })
      }
    })
  }
  deleteAlert = (id) => {
    api
      .delete('/alert/' + id)
      .then(res => {
        const isNew = _.find(this.alerts, { id: id, seen: false })
        const currentCategory = _.find(this.categories, { type: this.selectedCategory })
        if (isNew) currentCategory.newCount--
        currentCategory.count--
        this.alerts = this.alerts.filter(a => a.id !== id)
        this.selectedCategory = currentCategory.count ? currentCategory.type : _.find(this.categories, function (c) { return c.count > 0 }).type
      })
      .catch((err, a) => {
        throw new Error(extractError(err))
      })
  }
  handleClick = (e, type) => {
    e.preventDefault()
    this.selectedCategory = type
  }
}

export default AlertStore
